import { render, staticRenderFns } from "./BlackListEditor.vue?vue&type=template&id=8c152e84&scoped=true"
import script from "./BlackListEditor.vue?vue&type=script&lang=js"
export * from "./BlackListEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c152e84",
  null
  
)

export default component.exports